import React, { useEffect, useRef, useState } from 'react'
import { useCountUp } from 'react-countup'
import { Text } from '@pancakeswap-libs/uikit'

interface CardValueProps {
  value: number
  decimals?: number
  fontSize?: string
  prefix?: string
}

const CardValue: React.FC<CardValueProps> = ({ value, decimals, fontSize = '40px', prefix }) => {

	
	const [lastValue,setLast]=useState(0);

	useEffect(()=>{
		if(value!==lastValue){
			setLast(value)
		}
	},[value,lastValue])

	const countUpRef = React.useRef(null);

  useCountUp({
	ref: countUpRef,
    start: lastValue,
    end: value,
    duration: 1,
    separator: ',',
    decimals: decimals !== undefined ? decimals : value < 0 ? 4 : value > 1e5 ? 0 : 3,
  })

  return (
    <Text bold fontSize={fontSize}>
      {prefix}<span ref={countUpRef}/>
    </Text>
  )
}

export default CardValue
